
import { defineComponent } from "vue";
import { IComponentsNavigationBarConfig } from "../types";
import RunTime from "../components/time/RunTime.vue";
import TimeToggleButton from "../components/time/TimeToggleButton.vue";

export default defineComponent({
  name: "Run4Run",
  components: { RunTime, TimeToggleButton },
  methods: {
    getNavigationBarConfig(): IComponentsNavigationBarConfig {
      return {
        hideNavigationBar: true,
        disableDrawerSwipeGestures: true,
      };
    },
  },
});
